/**
 * @prettier
 * @flow
 */

export const appVersion: string = '1.1.1';
